// Styles
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'
import 'vue-toast/dist/vue-toast.min.css'
import '@fortawesome/fontawesome'
import '@fortawesome/fontawesome-free-brands'
import './assets/styles/animate.css'
import './assets/styles/bootstrap-formhelpers.min.css'
import './assets/styles/simple-line-icons.css'
// import '@fortawesome/fontawesome-free-solid/faSpinner'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuetify from 'vuetify'
import VeeValidate from 'vee-validate'
import Toasted from 'vue-toasted'
import VCharts from 'v-charts'
import VShowSlide from 'v-show-slide'

import VueLocalStorage from 'vue-localstorage'
import Router from 'vue-router'

// Directives
import role from './directives/role'

import './components/_globals'
import { createRouter } from './router/index'
import store from './store'
import services from './services'
import settings from './settings'

const moment = require('moment')
Vue.use(require('vue-moment'), { moment })

Vue.use(Toasted, {
  type: 'success',
  position: 'top-right',
  duration: 5000,
  action: {
    text: 'Close',
    onClick: (e, toastObject) => {
      toastObject.goAway(0)
    }
  }
})

Vue.use(Vuetify, {})
Vue.use(VeeValidate)
Vue.use(services)
Vue.use(VCharts)
Vue.use(VShowSlide)
Vue.use(Toasted, {
  duration: 4000,
  type: 'info'
})
Vue.use(VueLocalStorage)
Vue.use(Router)

Vue.directive('role', role)

store.commit('SET_API_URL', `${settings.apiUrl}`)
store.commit('SET_APP_NAME', `${settings.appName}`)
Vue.config.productionTip = false

let router = createRouter()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js